import { createRouter, createWebHistory } from 'vue-router'
import { isLoggedIn, clearTokens } from '@/utils/token.js'
import LoginPage from '@/views/LoginPage.vue'
import DashboardPage from '@/views/dashboard/DashboardPage.vue'
import WorkShareListPage from '@/views/work-share/WorkShareListPage.vue'
import WorkShareFormPage from '@/views/work-share/WorkShareFormPage.vue'
import WorkShareDetailPage from '@/views/work-share/WorkShareDetailPage.vue'
import StorageManagementPage from '@/views/storage/StorageManagementPage.vue'
import StorageRequestDetailPage from '@/views/storage/StorageRequestDetailPage.vue'
import OrderListPage from '@/views/order/OrderListPage.vue'
import OrderDetailPage from '@/views/order/OrderDetailPage.vue'
import OrderStatusPage from '@/views/order/OrderStatusPage.vue'
import ProductWithdrawalDetailPage from '@/views/order/ProductWithdrawalDetailPage.vue'
import SettlementListPage from '@/views/settlement/SettlementListPage.vue'
import MemberListPage from '@/views/members/MemberListPage.vue'
import MemberDetailPage from '@/views/members/MemberDetailPage.vue'
import BranchListPage from '@/views/branches/BranchListPage.vue'
import BranchCreatePage from '@/views/branches/BranchCreatePage.vue'
import BranchDetailPage from '@/views/branches/BranchDetailPage.vue'
import HeadAdminListPage from '@/views/branches/HeadAdminListPage.vue'
import BusinessCalendarPage from '@/views/business-calendar/BusinessCalendarPage.vue'
// 정산관리 (통합원장 전체 조회)
import InquiryListPage from '@/views/inquiry/InquiryListPage.vue'
import InquiryDetailPage from '@/views/inquiry/InquiryDetailPage.vue'
import SiteBoardListPage from '@/views/site-board/SiteBoardListPage.vue'
import SiteBoardFormPage from '@/views/site-board/SiteBoardFormPage.vue'
import MediaHubPage from '@/views/media-hub/MediaHubPage.vue'
import MediaHubMainBannerPage from '@/views/media-hub/MediaHubMainBannerPage.vue'
import MediaHubStatisticsPage from '@/views/media-hub/MediaHubStatisticsPage.vue'
import MainDisplayPage from '@/views/main-display/MainDisplayPage.vue'
// 상품관리
import CategoryListPage from '@/views/products/CategoryListPage.vue'
import BrandListPage from '@/views/products/BrandListPage.vue'
import ProductListPage from '@/views/products/ProductListPage.vue'
import ProductAccountListPage from '@/views/products/ProductAccountListPage.vue'
import InventoryLedgerPage from '@/views/products/InventoryLedgerPage.vue'
import ProductStockManagementPage from '@/views/inventory/ProductStockManagementPage.vue'
import InventoryTransferPage from '@/views/inventory/InventoryTransferPage.vue'
import ShippingFeePolicyPage from '@/views/products/ShippingFeePolicyPage.vue'
import PaymentLimitPolicyPage from '@/views/products/PaymentLimitPolicyPage.vue'
import ShippingRemoteAreaPage from '@/views/products/ShippingRemoteAreaPage.vue'
import ProductLabelListPage from '@/views/products/ProductLabelListPage.vue'
import ProductDeliveryExchangeTemplatePage from '@/views/products/ProductDeliveryExchangeTemplatePage.vue'
import ProductCreatePage from '@/views/products/ProductCreatePage.vue'
import ProductDetailPage from '@/views/products/ProductDetailPage.vue'
import B2bCompanyCategoryPage from '@/views/b2b/B2bCompanyCategoryPage.vue'
import B2bCompanyListPage from '@/views/b2b/B2bCompanyListPage.vue'
import B2bCompanyDetailPage from '@/views/b2b/B2bCompanyDetailPage.vue'
import B2bEvidenceRequestPage from '@/views/b2b/B2bEvidenceRequestPage.vue'
// 정책설정 (HQ 전용)
// 현물시세 (HQ 전용)
import MetalPricePage from '@/views/metal-price/MetalPricePage.vue'
// 시세 관리 - 해외 시세 / KRX 금현물 (HQ 전용)
import OverseasPricePage from '@/views/market/OverseasPricePage.vue'
import FeePolicyPage from '@/views/market/FeePolicyPage.vue'
import MarketChartPage from '@/views/market/MarketChartPage.vue'
import KrxReceiveStatusPage from '@/views/market/KrxReceiveStatusPage.vue'
import KrxTradePage from '@/views/market/KrxTradePage.vue'
import KrxArchivePage from '@/views/market/KrxArchivePage.vue'
import KrxFramePage from '@/views/market/KrxFramePage.vue'
import ImageGuidePage from '@/views/ImageGuidePage.vue'
import { getAdminInfo } from '@/utils/token.js'

function requireHq(to, from, next) {
  const { adminType } = getAdminInfo()
  if (adminType !== 'HQ') {
    next('/dashboard')
  } else {
    next()
  }
}

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/login' },
    {
      path: '/login',
      component: LoginPage,
      meta: { layout: 'blank', title: '로그인', public: true },
    },
    {
      path: '/dashboard',
      component: DashboardPage,
      meta: { title: '대시보드' },
    },
    {
      path: '/work-share',
      component: WorkShareListPage,
      meta: { title: '업무공유게시판' },
    },
    {
      path: '/work-share/new',
      component: WorkShareFormPage,
      meta: { title: '업무공유 등록' },
    },
    {
      path: '/work-share/:workSharePostCode/edit',
      component: WorkShareFormPage,
      meta: { title: '업무공유 수정' },
    },
    {
      path: '/work-share/:workSharePostCode',
      component: WorkShareDetailPage,
      meta: { title: '업무공유 상세' },
    },
    {
      path: '/storage',
      component: StorageManagementPage,
      meta: { title: '보관/이동 관리' },
    },
    {
      path: '/storage/requests/:storageRequestCode',
      component: StorageRequestDetailPage,
      meta: { title: '보관/이동 상세' },
    },
    {
      path: '/orders',
      component: OrderListPage,
      meta: { title: '주문 관리' },
    },
    {
      path: '/orders/:orderCode',
      component: OrderDetailPage,
      meta: { title: '주문 상세' },
    },
    {
      path: '/order-status/:paymentCode',
      component: ProductWithdrawalDetailPage,
      meta: { title: '인출 상세' },
    },
    {
      path: '/order-status',
      component: OrderStatusPage,
      meta: { title: '인출하기' },
    },
    {
      path: '/settlement',
      component: SettlementListPage,
      meta: { title: '정산 관리' },
    },
    {
      path: '/members',
      component: MemberListPage,
      meta: { title: '회원관리' },
    },
    {
      path: '/members/:userCode',
      component: MemberDetailPage,
      meta: { title: '회원 상세' },
    },
    {
      path: '/branches',
      component: BranchListPage,
      meta: { title: '지점관리' },
    },
    {
      path: '/branches/head-admins',
      component: HeadAdminListPage,
      meta: { title: '본사관리자 관리', hqOnly: true },
      beforeEnter: requireHq,
    },
    {
      path: '/branches/create',
      component: BranchCreatePage,
      meta: { title: '지점 등록' },
    },
    {
      path: '/branches/:branchCode',
      component: BranchDetailPage,
      meta: { title: '지점 상세' },
    },
    {
      path: '/business-calendar',
      component: BusinessCalendarPage,
      meta: { title: '영업일 관리' },
    },
    {
      path: '/inquiries',
      component: InquiryListPage,
      meta: { title: '1:1 문의' },
    },
    {
      path: '/inquiries/:boardCode',
      component: InquiryDetailPage,
      meta: { title: '1:1 문의 상세' },
    },
    {
      path: '/notices',
      component: SiteBoardListPage,
      meta: { title: '공지사항', boardKind: 'notice' },
      beforeEnter: requireHq,
    },
    {
      path: '/notices/new',
      component: SiteBoardFormPage,
      meta: { title: '공지 등록', boardKind: 'notice' },
      beforeEnter: requireHq,
    },
    {
      path: '/notices/:boardCode',
      component: SiteBoardFormPage,
      meta: { title: '공지 수정', boardKind: 'notice' },
      beforeEnter: requireHq,
    },
    {
      path: '/faqs',
      component: SiteBoardListPage,
      meta: { title: '자주묻는 질문', boardKind: 'faq' },
      beforeEnter: requireHq,
    },
    {
      path: '/faqs/new',
      component: SiteBoardFormPage,
      meta: { title: 'FAQ 등록', boardKind: 'faq' },
      beforeEnter: requireHq,
    },
    {
      path: '/faqs/:boardCode',
      component: SiteBoardFormPage,
      meta: { title: 'FAQ 수정', boardKind: 'faq' },
      beforeEnter: requireHq,
    },
    {
      path: '/media-hub',
      redirect: '/media-hub/main-banners',
      beforeEnter: requireHq,
    },
    {
      path: '/media-hub/main-banners',
      component: MediaHubMainBannerPage,
      meta: { title: '미디어허브 메인배너 관리', hqOnly: true },
      beforeEnter: requireHq,
    },
    {
      path: '/media-hub/statistics',
      component: MediaHubStatisticsPage,
      meta: { title: '미디어허브 통계', hqOnly: true },
      beforeEnter: requireHq,
    },
    {
      path: '/media-hub/source-categories',
      component: MediaHubPage,
      meta: { title: '수집카테고리 관리', hqOnly: true, mediaHubSection: 'sourceCategories' },
      beforeEnter: requireHq,
    },
    {
      path: '/media-hub/sources',
      component: MediaHubPage,
      meta: { title: '수집사이트 관리', hqOnly: true, mediaHubSection: 'sources' },
      beforeEnter: requireHq,
    },
    {
      path: '/media-hub/categories',
      component: MediaHubPage,
      meta: { title: '미디어허브 카테고리 관리', hqOnly: true, mediaHubSection: 'displayCategories' },
      beforeEnter: requireHq,
    },
    {
      path: '/media-hub/contents',
      component: MediaHubPage,
      meta: { title: '수집 콘텐츠 관리', hqOnly: true, mediaHubSection: 'contents' },
      beforeEnter: requireHq,
    },
    {
      path: '/media-hub/exposures',
      component: MediaHubPage,
      meta: { title: '홈페이지 노출 콘텐츠 관리', hqOnly: true, mediaHubSection: 'exposures' },
      beforeEnter: requireHq,
    },
    {
      path: '/media-hub/image-guide',
      component: ImageGuidePage,
      meta: { title: '이미지 제작 가이드', hqOnly: true },
      beforeEnter: requireHq,
    },
    // 상품관리
    {
      path: '/main-display',
      component: MainDisplayPage,
      meta: { title: '메인화면 관리', hqOnly: true },
      beforeEnter: requireHq,
    },
    {
      path: '/b2b/company-categories',
      component: B2bCompanyCategoryPage,
      meta: { title: 'B2B 업체분류 관리', hqOnly: true },
      beforeEnter: requireHq,
    },
    {
      path: '/b2b/companies',
      component: B2bCompanyListPage,
      meta: { title: 'B2B 업체 관리', hqOnly: true },
      beforeEnter: requireHq,
    },
    {
      path: '/b2b/companies/:companyCode',
      component: B2bCompanyDetailPage,
      meta: { title: 'B2B 특가상품 관리', hqOnly: true },
      beforeEnter: requireHq,
    },
    {
      path: '/b2b/evidence-requests',
      component: B2bEvidenceRequestPage,
      meta: { title: '증빙 발행요청 관리', hqOnly: true },
      beforeEnter: requireHq,
    },
    {
      path: '/products/accounts',
      component: ProductAccountListPage,
      meta: { title: '입금계좌 관리' },
    },
    {
      path: '/inventory/products',
      component: ProductStockManagementPage,
      meta: { title: '상품별 재고관리', hqOnly: true },
      beforeEnter: requireHq,
    },
    {
      path: '/inventory/transfers',
      component: InventoryTransferPage,
      meta: { title: '지점 입고확인' },
    },
    {
      path: '/inventory/ledgers',
      component: InventoryLedgerPage,
      meta: { title: '재고 원장' },
    },
    {
      path: '/products/inventory-ledgers',
      redirect: '/inventory/ledgers',
    },
    {
      path: '/products/shipping-fees',
      component: ShippingFeePolicyPage,
      meta: { title: '배송비 관리', hqOnly: true },
      beforeEnter: requireHq,
    },
    {
      path: '/products/payment-limits',
      component: PaymentLimitPolicyPage,
      meta: { title: '결제 한도 관리', hqOnly: true },
      beforeEnter: requireHq,
    },
    {
      path: '/products/remote-areas',
      component: ShippingRemoteAreaPage,
      meta: { title: '도서산간 지역 관리', hqOnly: true },
      beforeEnter: requireHq,
    },
    {
      path: '/products/categories',
      component: CategoryListPage,
      meta: { title: '상품 카테고리 관리', hqOnly: true },
      beforeEnter: requireHq,
    },
    {
      path: '/products/brands',
      component: BrandListPage,
      meta: { title: '브랜드 관리', hqOnly: true },
      beforeEnter: requireHq,
    },
    {
      path: '/products/labels',
      component: ProductLabelListPage,
      meta: { title: '상품라벨관리', hqOnly: true },
      beforeEnter: requireHq,
    },
    {
      path: '/products/delivery-exchange-templates',
      component: ProductDeliveryExchangeTemplatePage,
      meta: { title: '배송/교환 안내 관리' },
    },
    {
      path: '/products',
      component: ProductListPage,
      meta: { title: '상품 관리' },
    },
    {
      path: '/products/create',
      component: ProductCreatePage,
      meta: { title: '상품 등록' },
    },
    {
      path: '/products/:productCode',
      component: ProductDetailPage,
      meta: { title: '상품 상세' },
    },
    // 현물시세 (HQ 전용) - 금/은 시세 이력 차트
    {
      path: '/metal-price',
      component: MetalPricePage,
      meta: { title: '현물시세', hqOnly: true },
      beforeEnter: (to, from, next) => {
        const { adminType } = getAdminInfo()
        if (adminType !== 'HQ') {
          next('/dashboard')
        } else {
          next()
        }
      },
    },
    // ── 시세 관리 (HQ 전용) ──────────────────────────────────────────
    // 수수료: 수집한 시세에 얹어 고객가를 만드는 값. 법인(골드나라/아우라)별로 나눈다.
    // 값은 공용 서버에 있고 이 화면이 관리한다 - 거기가 고시가를 계산하는 자리다.
    {
      path: '/market/fee-policies',
      component: FeePolicyPage,
      meta: { title: '시세 수수료', hqOnly: true },
      beforeEnter: requireHq,
    },
    // 차트: 수수료를 얹은 고객가를 기간으로 본다. 점마다 그때 수수료가 붙는다.
    {
      path: '/market/chart',
      component: MarketChartPage,
      meta: { title: '시세 차트', hqOnly: true },
      beforeEnter: requireHq,
    },
    // 해외 시세: metals-api.com 금/은/백금.
    // 기존 /metal-price(metals.dev 금/은)는 그대로 둔다 - 쓰는 화면이 있다.
    {
      path: '/market/overseas',
      component: OverseasPricePage,
      meta: { title: '해외 시세', hqOnly: true },
      beforeEnter: requireHq,
    },
    // KRX 금현물: 코스콤에서 직접 받는 국내 거래소 실시간 시세.
    {
      path: '/market/krx/status',
      component: KrxReceiveStatusPage,
      meta: { title: 'KRX 수신 현황', hqOnly: true },
      beforeEnter: requireHq,
    },
    {
      path: '/market/krx/trades',
      component: KrxTradePage,
      meta: { title: 'KRX 금현물 시세', hqOnly: true },
      beforeEnter: requireHq,
    },
    {
      path: '/market/krx/archive',
      component: KrxArchivePage,
      meta: { title: 'KRX 원본 보관', hqOnly: true },
      beforeEnter: requireHq,
    },
    // 전용 화면이 없는 전문을 이 하나가 대신한다. 전문 종류마다 화면을 만들면
    // 열 개가 넘는데 대부분은 1년에 몇 번 볼까 말까다.
    {
      path: '/market/krx/frames',
      component: KrxFramePage,
      meta: { title: 'KRX 원천 전문', hqOnly: true },
      beforeEnter: requireHq,
    },
    { path: '/:pathMatch(.*)*', redirect: '/dashboard' },
  ],
})

router.beforeEach((to, from, next) => {
  const loggedIn = isLoggedIn()
  if (!to.meta?.public && !loggedIn) {
    // 토큰이 없거나 접근 · 갱신 토큰의 exp 가 둘 다 지났다 - 화면을 그리기 전에 로그인으로 보낸다(모달 없이).
    // 끝난 세션이니 남은 토큰 · 관리자 정보도 지운다.
    clearTokens()
    next({ path: '/login', replace: true })
  } else if (to.path === '/login' && loggedIn) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router
